export interface IUser {
  email: string;
  id: number;
  username: string;
}

export class UserHeader implements IUser {
  constructor(
    readonly id: number,
    readonly username: string,
    readonly email: string
  ) {}
}

export class User implements IUser {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly data: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(data: any) {
    this.data = data;
  }

  get id(): number {
    return this.data['id'];
  }

  get username(): string {
    return this.data['username'];
  }

  get email(): string {
    return this.data['email'];
  }
}
